@if (noSorting()) {
    <mat-icon [matTooltip]="'Alphabetical Sort '" matTooltipPosition="right" style="opacity: 0.3">
        swap_vert
    </mat-icon>
}
@if (isDescending()) {
    <mat-icon [matTooltip]="'Descending'" matTooltipPosition="right">arrow_downward</mat-icon>
}
@if (isAscending()) {
    <mat-icon [matTooltip]="'Ascending'" matTooltipPosition="right">arrow_upward</mat-icon>
}
